<template>
  <div class="home">
    <div class="register-inner">
      <h2 style="text-align:center;margin-top:0;">تکمیل ثبت‌ نام</h2>
      <div class="image-inner">
        <UploadSingleImage toAction="user_mobile" url="register/" @uploaded="handleImageUpload" />
      </div>
      <RegisterForm :image-id="imageId" />
    </div>
  </div>
</template>
<script setup>
import RegisterForm from '@/components/user/RegisterForm.vue';
import UploadSingleImage from '@/components/tooles/upload/UploadSingleImage.vue';
import { ref } from 'vue';
const imageId=ref(null)
const handleImageUpload = (id) => {
  imageId.value = id;
}
</script>
<style scoped>
  .home{
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: nowrap;
    direction: rtl;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 50px;
    width: 100%;
    gap: 20px;
  }
  .register-inner{
    width: 50%;
    margin:0 auto;
    box-sizing: border-box;
    border-radius: 10px;
    background: #e0e4ed;
    padding: 20px;
    box-shadow: 0 0 10px grey;
  }
  .image-inner{
    background-color: #1a6785;
    height: 190px;
    width:90%;
    margin:0 auto;
    border-radius: 10px;
    box-shadow: 0 0 10px grey;
  }
  @media screen and (max-width:600px){
    .home{
      flex-direction: column;
      margin-top: 20px;
    }
    .register-inner{
      width: 90%;
    }
  }
</style>